import { useEffect, useState, type ReactElement } from 'react';
import Loader from '../Loader';
import type { IForm } from '../../interfaces/model/IForm.interface';
import { type IPayload, postInscription } from '../../services/datosGenerales.service';
import Notificacion from '../Notificacion';

const ResponseAlta = ({ formData }: { readonly formData: IForm }): ReactElement => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [code, setCode] = useState<number | undefined>(undefined);

	const contentSuccess = {
		titulo: 'Inscripción realizada correctamente',
		detalle: 'En breve recibirá confirmación de su inscripción',
	};

	const contentError = {
		titulo: 'No se ha podido realizar la inscripción',
		detalle: 'Por favor, pulse el siguiente botón y vuelva a intentarlo',
	};
	const sendResponse = async () => {
		try {
			const { privacyPolicy, ...sendData } = formData;
			const payload: IPayload = {
				aplicacion: 'jornadas-tecnologia-3',
				formulario: sendData,
			};
			const response = await postInscription(payload);
			setIsLoading(false);
			setCode(response.code);
		} catch (error) {
			setIsLoading(false);
			setCode(500);
		}
	};
	useEffect(() => {
		if (formData) sendResponse();
	}, [formData]);

	if (isLoading) {
		return <Loader />;
	}
	return <Notificacion code={code ?? 0} contentSuccess={contentSuccess} contentError={contentError} />;
};

export default ResponseAlta;
